export class CategoryWiseMessageCountDto {
  allQueries: number;
  myQueries: number;
}
